<template lang="pug">
  tr
    td {{ entry['#'] }}
    td {{ entry.expirationDate | formatDate('D/MM/YY') }}
    td {{ entry.initialBalance | formatNumber(currency) }}
    td {{ entry.amortization | formatNumber(currency) }}
    td {{ entry.interest | formatNumber(currency) }}
    td {{ Insurances | formatNumber(currency) }}
    td {{ entry.defaultsAndPenalties | formatNumber(currency) }}
    td {{ entry.fee | formatNumber(currency) }}
    td {{ entry.totalPaid | formatNumber(currency) }}
    td {{ entry.totalAmortization | formatNumber(currency) }}
    td {{ entry.finalBalance | formatNumber(currency) }}
    td {{ entry.paymentDate | formatDate('D/MM/YY') }}
    td {{ $t(`quoteStatus.${entry.status.toUpperCase()}`) }}
</template>

<script>
export default {
  name: 'borrower-statement-table-row',

  props: {
    entry: { type: Object },
    currency: { type: Object },
  },
  computed: {
      Insurances() {
        return this.entry.lifeInsurance * 1 + this.entry.propertyInsurance * 1
      },
  },
};

</script>

<style lang="sass" scoped>

</style>
